var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ApiKeyManager"},[_c('new-api-key-button'),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.apikeys,"items-per-page":25,"footer-props":{
        itemsPerPageOptions:[10,25,50,-1]
      }},scopedSlots:_vm._u([{key:`item.actions`,fn:function({ item }){return [_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteKey(item)}}},[_vm._v(" mdi-delete ")])]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }